/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, arrayOf, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { EmailRecipientMapper } from './email-recipients.mapper';
import { EmailRecipientDto } from './email-recipients.model';

@Injectable()
export class EmailRecipientRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  get(): Observable<EmailRecipientDto[]> {
    return this.httpGet(`${this.bp}/email-recipients`, arrayOf(EmailRecipientMapper));
  }

  save(recipients: EmailRecipientDto[]): Observable<EmailRecipientDto[]> {
    return this.httpPut(`${this.bp}/email-recipients`, recipients, arrayOf(EmailRecipientMapper));
  }
}
